import { Divider, Skeleton } from "antd"
import { divide } from "lodash"
export default function ListSkeleton({avatar = true, input = true, button = true, divider = true}) {
    return (
        <div>
        <div style={{display:"flex", justifyContent:"space-between"}}>
            <div style={{display:"flex", alignItems:"center", gap:10}}>
                {avatar && <Skeleton.Avatar active size={40} shape={"circle"} />}
                {input && <Skeleton.Input active size={32} style={{ width: 200}} />}
            </div>
            {button && <Skeleton.Button active  block={false} />}
        </div>
            {divider && <Divider />}
        </div>
    )
} 